import React, { useEffect, useState } from "react"
import { useParams, useHistory } from "react-router-dom"
import UpdateUserForm from "../components/UpdateUserForm"
import { useUserService } from "../hooks/useUserService"
import { message } from "antd"

import CustomButton from "../../../v2-components/Antd/Button"

const UserDetailPage = () => {
    const { email } = useParams()
    const history = useHistory()
    const [userData, setUserData] = useState(null)
    const { findUserByEmail, updateUserStatus } = useUserService()

    useEffect(() => {
        let isMounted = true

        const loadUserData = async () => {
            try {
                const user = await findUserByEmail(email)

                if (isMounted) {
                    if (user && user.length > 0) {
                        const filteredData = {
                            id: user[0]._id,
                            email: user[0].email,
                            first_name: user[0].first_name,
                            last_name: user[0].last_name,
                            roles: user[0].roles,
                            pharmacy: user[0].pharmacy,
                            eneable: user[0].eneable,
                        }
                        setUserData(filteredData)
                    }
                }
            } catch {
                if (isMounted) {
                    message.error("Error al cargar los datos del usuario")
                }
            }
        }

        loadUserData()

        return () => {
            isMounted = false
        }
    }, [email, findUserByEmail])

    const handleUpdateUser = async (updatedData) => {
        try {
            // quitar el campo pharmacy
            const { pharmacy, ...rest } = updatedData
            const success = await updateUserStatus(userData.id, rest)
            if (success) {
                message.success("Usuario actualizado correctamente")
                setUserData(updatedData)
            } else {
                message.error("Error al actualizar el usuario")
            }
        } catch (error) {
            message.error("Error al actualizar los datos del usuario")
        }
    }

    const handleCancel = () => {
        history.push("/v2/admin-user-management?tab=2")
    }

    return (
        <div className="container">
            <h2 className="page-title">{email}</h2>
            <CustomButton className="no-padding-button" type="link" onClick={handleCancel}>Volver a usuarios</CustomButton>
            {userData ? (
                <UpdateUserForm values={userData} onFinish={handleUpdateUser} loading={false} />
            ) : (
                <div>Cargando...</div>
            )}
        </div>
    )
}

export default UserDetailPage
